import { isRecord } from "../../types/data";

const toRatingValue = (value: unknown): number | null => {
  if (value == null || String(value).trim() === "") return null;
  const rating = Number(String(value).replace(",", "."));
  return Number.isFinite(rating) ? parseFloat(rating.toFixed(2)) : null;
};

const getAverageRating = (values: unknown[] = []) => {
  const ratings = values.map(toRatingValue).filter((value): value is number => value != null);
  if (!ratings.length) return null;
  return parseFloat((ratings.reduce((sum, value) => sum + value, 0) / ratings.length).toFixed(2));
};

export const getMovieRating = (movie: unknown = {}): number | null => {
  const source = isRecord(movie) ? movie : {};
  if (source.userRate != null && String(source.userRate).trim() !== "") {
    if (Number(source.ratingModelVersion) >= 2 && source.overallRatingExplicit !== true) {
      return null;
    }
    const rating = toRatingValue(source.userRate);
    if (rating === 0 && source.importSource === "ratings-table") return null;
    return rating;
  }

  // From model v2 onward the simple score, detailed criteria and season
  // scores are independent. The fallbacks below remain only for untouched
  // legacy documents whose userRate used to be generated from another mode.
  if (Number(source.ratingModelVersion) >= 2) return null;

  if (source.detailedRate && typeof source.detailedRate === "object") {
    return getAverageRating(Object.values(source.detailedRate));
  }

  if (source.seasonRatings && typeof source.seasonRatings === "object") {
    return getAverageRating(
      Object.values(source.seasonRatings).map((season: unknown) => {
        if (!isRecord(season)) return undefined;
        return isRecord(season.userRate) ? season.userRate.userRate : season.userRate;
      })
    );
  }

  return null;
};
